import { actionTypes } from '@/core/constants'
import PenalidadesNotificacoesApiClient from '@/core/apiclient/penalidades/notificacoes/PenalidadesNotificacoesApiClient'
import PenalidadesUrlBuilder from '@/core/utils/factory/penalidades/PenalidadesUrlBuilder'

function getApiClient(obj) {
	const urlBuilder = new PenalidadesUrlBuilder(obj.tipo)
	return new PenalidadesNotificacoesApiClient(urlBuilder)
}

export default {
	async [actionTypes.PENALIDADES.NOTIFICACOES.BUSCAR_NOTIFICACOES_PENALIDADE](context, objt) {
		let apiClient = getApiClient(objt)
		let { data } = await apiClient.buscarNotificacoesPenalidade(objt)
		return data
	},
	async [actionTypes.PENALIDADES.NOTIFICACOES.INSERIR_NOTIFICACAO_PENALIDADE](context, objt) {
		let apiClient = getApiClient(objt)
		const { tipo, ...dados } = objt
		let { data } = await apiClient.inserirNotificacaoPenalidade({ tipo: tipo.value, ...dados })
		return data
	},
}
